module.exports = __webpack_public_path__ + "img/changeover_actif.416fd193.png";